export enum SSOType {
  SAML = 'SAML',
  OIDC = 'OIDC',
}

export interface MenuItem {
  icon: React.ReactNode;
  text: string;
  url: string;
}

export interface SettingsMenuSection {
  title: string;
  items: MenuItem[];
}
